import { useMemo } from 'react';
import * as React from 'react';

import { BetType } from '@/lib/apollo/types/gen/graphql';
import { getCompositeOdds } from '@/lib/race';
import { Odds } from '@/modelTypes';

const CompositeOdds: React.FC<{
  odds: Odds | null;
  setNums: number[];
  betType: BetType;
}> = ({ odds, setNums, betType }) => {
  const compositeOdds = useMemo(() => {
    if (!odds) {
      return null;
    }
    return getCompositeOdds(odds, setNums, betType);
  }, [odds, setNums, betType]);

  if (!compositeOdds) {
    return <>-</>;
  }
  return <>{compositeOdds.toFixed(1)}</>;
};

export default CompositeOdds;
